window.TISPFeaturedTracks = (function () {
  var activeAudio = null;
  var activeButton = null;

  function stopActive(root) {
    var fallbackRoot = root || (activeButton && activeButton.closest('.ft-section'));
    if (activeAudio) {
      try { activeAudio.pause(); } catch (e) {}
    }
    if (activeButton) {
      activeButton.classList.remove('is-playing');
      var playIcon = activeButton.querySelector('.ft-icon-play');
      var pauseIcon = activeButton.querySelector('.ft-icon-pause');
      if (playIcon) playIcon.hidden = false;
      if (pauseIcon) pauseIcon.hidden = true;
      hideCardVideo(activeButton.closest('.ft-card'));
    }
    hideMiniPlayer(fallbackRoot);
    activeAudio = null;
    activeButton = null;
  }

  function showCardVideo(card) {
    var video = card.querySelector('[data-ft-video]');
    if (!video) return;
    var img = card.querySelector('.ft-card__art-img, .ft-card__art-placeholder');
    if (!video.src) {
      var src = video.getAttribute('data-video-src');
      if (!src) return;
      video.src = src;
      video.addEventListener('error', function () {
        video.hidden = true;
        if (img) img.hidden = false;
      });
    }
    video.hidden = false;
    if (img) img.hidden = true;
    video.currentTime = 0;
    video.play().catch(function () {
      // autoplay blocked or format unsupported (e.g. older Safari) — fall back to the static image
      video.hidden = true;
      if (img) img.hidden = false;
    });
  }

  function hideCardVideo(card) {
    if (!card) return;
    var video = card.querySelector('[data-ft-video]');
    var img = card.querySelector('.ft-card__art-img, .ft-card__art-placeholder');
    if (video) {
      try { video.pause(); } catch (e) {}
      video.hidden = true;
    }
    if (img) img.hidden = false;
  }

  function handlePlayClick(button) {
    var card = button.closest('.ft-card');
    var root = button.closest('.ft-section');
    var url = button.getAttribute('data-audio-url');
    var titleEl = card.querySelector('.ft-card__title');
    var title = titleEl ? titleEl.textContent : '';

    var wasActiveButton = button === activeButton;
    if (wasActiveButton) {
      stopActive(root);
      return;
    }

    stopActive(root);

    activeButton = button;
    button.classList.add('is-playing');
    button.querySelector('.ft-icon-play').hidden = true;
    button.querySelector('.ft-icon-pause').hidden = false;

    showMiniPlayer(root, title);
    showCardVideo(card);

    if (!button._audio) {
      var audio = new Audio(url);
      button._audio = audio;
      audio.addEventListener('timeupdate', function () {
        if (activeButton === button) updateMiniPlayerProgress(root, audio);
      });
      audio.addEventListener('ended', function () {
        if (activeButton === button) stopActive(root);
      });
    }
    activeAudio = button._audio;
    activeAudio.currentTime = 0;
    activeAudio.play();
  }

  function showMiniPlayer(root, title) {
    if (!root) return;
    var mp = root.querySelector('[data-ft-miniplayer]');
    if (!mp) return;
    mp.hidden = false;
    var titleEl = mp.querySelector('[data-ft-miniplayer-title]');
    if (titleEl) titleEl.textContent = title;
    var toggle = mp.querySelector('[data-ft-miniplayer-toggle]');
    if (toggle) {
      toggle.querySelector('.ft-mp-icon-play').hidden = true;
      toggle.querySelector('.ft-mp-icon-pause').hidden = false;
    }
  }

  function hideMiniPlayer(root) {
    if (!root) return;
    var mp = root.querySelector('[data-ft-miniplayer]');
    if (!mp) return;
    mp.hidden = true;
    var fill = mp.querySelector('[data-ft-miniplayer-fill]');
    if (fill) fill.style.width = '0%';
    var time = mp.querySelector('[data-ft-miniplayer-time]');
    if (time) time.textContent = '';
  }

  function updateMiniPlayerProgress(root, audio) {
    if (!root) return;
    var mp = root.querySelector('[data-ft-miniplayer]');
    if (!mp) return;
    var duration = audio.duration || 0;
    var current = audio.currentTime || 0;
    var pct = duration > 0 ? (current / duration) * 100 : 0;
    var fill = mp.querySelector('[data-ft-miniplayer-fill]');
    if (fill) fill.style.width = pct + '%';
    var time = mp.querySelector('[data-ft-miniplayer-time]');
    if (time) time.textContent = formatTime(current) + ' / ' + formatTime(duration);
  }

  function formatTime(seconds) {
    seconds = Math.max(0, Math.floor(seconds || 0));
    var m = Math.floor(seconds / 60);
    var s = seconds % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function handleAddToCart(button) {
    if (button.disabled) return;
    var variantId = button.getAttribute('data-variant-id');
    button.disabled = true;
    var originalText = button.textContent;
    button.textContent = 'Adding…';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        button.textContent = 'Added ✓';
        button.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        updateCartBubble();
        setTimeout(function () {
          button.textContent = originalText;
          button.classList.remove('is-added');
          button.disabled = false;
        }, 1600);
      })
      .catch(function (err) {
        button.textContent = 'Try again';
        button.disabled = false;
        console.error('TISP featured tracks: add to cart failed', err);
      });
  }

  function updateCartBubble() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function init(root) {
    if (!root || root._ftInitialized) return;
    root._ftInitialized = true;

    root.addEventListener('click', function (e) {
      var playBtn = e.target.closest('[data-ft-play]');
      if (playBtn) { handlePlayClick(playBtn); return; }

      var cartBtn = e.target.closest('[data-ft-add-to-cart]');
      if (cartBtn) { handleAddToCart(cartBtn); return; }

      var miniToggle = e.target.closest('[data-ft-miniplayer-toggle]');
      if (miniToggle) { if (activeButton) handlePlayClick(activeButton); return; }
    });
  }

  return { init: init };
})();
